import ChildTemplate from '../_/ChildTemplate';
import Style from './Style';

export default class extends ChildTemplate {
  data = null;
  style = new Style(this);

  get(key) {
    return this.data?.[key];
  }

  init(data) {
    this.data = data;
    this.style.init();
  }
}
